import { createSlice, createAsyncThunk } from '@reduxjs/toolkit';
import axios from 'axios';
const STOP_REGION = process.env.REACT_APP_STOP_REGION

export const getVerificationDischargeMasterReferenceData = createAsyncThunk(
  'stop/getVerificationDischargeMasterReferenceData',
  async (params) => {
    const { url, payload, authorization } = params;
    const config = {
      headers: {
        Authorization: authorization,
        Region: STOP_REGION
      },
    };
    const response = await axios
      .post(url, payload, config)
      .then((response) => {
        return response;
      })
      .catch((e) => {
        console.log(e);
        return e;
      });
    const data = await response.data.data;
    return data === undefined ? null : data;
  }
);

const verificationDischargeMasterReferenceSlice = createSlice({
  name: 'stop/verificationDischargeMasterReference',
  initialState: null,
  reducers: {
    resetVerificationDischargeMasterReference: () => null,
  },
  extraReducers: {
    [getVerificationDischargeMasterReferenceData.fulfilled]: (state, action) =>
      action.payload,
  },
});

export const { resetVerificationDischargeMasterReference } =
  verificationDischargeMasterReferenceSlice.actions;

export default verificationDischargeMasterReferenceSlice.reducer;
